import {Component, tag} from 'doz'
import defaultCover from '../../../resources/default-cover.png'
import adapters from './adapters'

@tag('last-songs')
export default class extends Component {
    props = {
        items: [],
        playlistSong:[]
    };

    template(h) {
        return h`
            <style>
                .container {
                    color: ${this.THEME.primaryColor};
                    background: ${this.PLAYER_CONFIG.lastSongsBackgroundColor || this.THEME.onPrimaryColor};
                    border-color: ${this.PLAYER_CONFIG.lastSongsSeparatorColor || ''};
                    min-height: 414px;
                }
                
                .img {
                    border-radius: 50%;
                    width: 80px;
                    height: 80px;
                    margin-right: 16px;
                    border: 2px solid ${this.PLAYER_CONFIG.lastSongsTrackImageBorderColor || this.THEME.primaryColorAlpha};
                }
                
                .row {
                    display: flex;
                    align-items: center;
                    margin: 16px 0;
                }
                
                .date-play {
                    font-size:11px; 
                    color: ${this.PLAYER_CONFIG.lastSongsTrackDatePlayColor || this.THEME.primaryColorDark};
                }
                
                .artist {
                    font-weight: bold; 
                    color: ${this.PLAYER_CONFIG.lastSongsTrackArtistColor || this.THEME.primaryColor}
                }
                
                .title {
                    text-transform: capitalize; 
                    color: ${this.PLAYER_CONFIG.lastSongsTrackTitleColor || this.THEME.primaryColorDark}
                }
                
                h3 {
                    color: ${this.PLAYER_CONFIG.lastSongsTitleColor || this.THEME.primaryColor};
                }
            </style>
            <div class="container">
                <h3>${this.PLAYER_CONFIG.lastSongsTitleText || 'Ultimi brani trasmessi'}</h3>
                <div>
                    ${this.each(this.props.items, item => h`
                        <div class="row animated fadeIn">
                            <div class="column-left">
                                <img class="img" src="${item.artwork ? item.artwork : defaultCover}">
                            </div>
                            <div class="right">
                                <div class="date-play" d-show="${!!item.datePlay}">${item.datePlay}</div>
                                <div class="artist">${item.artist}</div>
                                <div class="title">${item.title}</div>
                            </div>
                        </div>
                        
                    `)}
                </div>
            </div>
        `
    }

    /*onMount(){
        if (!this.PLAYER_CONFIG.lastSongUrl) return;
        const item = {
            artwork: this.props.defaultCover,
            artist: '',
            title: '',
        };
        for(let i=0; i < 5; i++){
            this.props.items.push(item);
        }
    }*/

    onMount() {
        if (this.isSSR()) return;
        this.getData();
        setInterval(() => this.getData(),10000);
    }

    getData(){
        const url = this.PLAYER_CONFIG.lastSongUrl;
        if (!url) return;
        const adapter = adapters[this.PLAYER_CONFIG.lastSongType];
        if (!adapter) return;

        this.axios.get(this.CORS_PROXY + url)
        //this.axios.get(url)
            .then(response => {
                if(response.data){
                    this.props.items = adapter(response.data);
                }
            })
            .catch (error => {
                console.error(error);
            });
    }

}
